// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetOfferCardStatisticRequest,
  TGetOfferCardStatisticModel,
  IMappers,
  TGetOfferCardStatisticResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetOfferCardStatisticResponseSchema } from '../../entities/offer_card_statistic/GetOfferCardStatisticResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetOfferCardStatisticModel(
  parameters: IGetOfferCardStatisticRequest,
): TGetOfferCardStatisticModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'offer-card',
    pathApi: '/v1/get-offer-card-statistic/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetOfferCardStatisticOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetOfferCardStatisticRequest;
}

export async function fetchGetOfferCardStatistic<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOfferCardStatisticOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetOfferCardStatisticResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetOfferCardStatisticModel(parameters),
    config,
  )) as FetchResponse<TGetOfferCardStatisticResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetOfferCardStatisticResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetOfferCardStatisticResponse>;
}
